const onBoardingSteps = [
  {
    element: '#menu-icon',
    popover: {
      title: 'Menu',
      description:
        'Simplificamos nosso menu para que seja mais rápido e fácil encontrar as diferentes ferramentas que você precisa.',
      side: 'bottom',
      align: 'start',
    },
  },
  {
    element: '#menu-drawer',
    popover: {
      title: 'Menu',
      description:
        'Todas as páginas são organizadas no menu lateral para facilitar a localização do que você precisa.',
    },
  },
  {
    element: '#home',
    popover: {
      title: 'Home',
      description:
        'Esta é a página principal e inicial do sistema, nesta página você encontra a visão geral e administração do sistema.',
    },
  },
  {
    element: '#constructions',
    popover: {
      title: 'Obras',
      description:
        'Adicione, edite ou remova obras nessa página dedicada ao gerenciamento das suas obras.',
    },
  },
  {
    element: '#clients',
    popover: {
      title: 'Clientes',
      description:
        'Adicione, edite ou remova clientes nessa página dedicada ao gerenciamento de seus clientes.',
    },
  },
  {
    element: '#suppliers',
    popover: {
      title: 'Fornecedores',
      description:
        'Adicione, edite ou remova fornecedores nessa página dedicada ao gerenciamento de seus fornecedores.',
    },
  },
  {
    element: '#categories',
    popover: {
      title: 'Categorias',
      description:
        'Adicione, edite ou remova categorias nessa página dedicada ao gerenciamento das suas categorias.',
    },
  },
  {
    element: '#tour-drawer',
    popover: {
      title: 'Tour Rápido',
      description:
        'Acesse o Tour Rápido a qualquer momento para completar o percurso ou revisitar tópicos específicos sempre que precisar relembrar alguma funcionalidade.',
    },
  },
];

const homeSteps = [
  {
    element: '#payable-dropdown',
    popover: {
      title: 'Arraste o Boleto',
      description:
        'Leitura automática dos dados do boleto, identificação de fornecedor e cliente.',
      side: 'bottom',
      align: 'center',
    },
  },
  {
    element: '#payables',
    popover: {
      title: 'Novo Lançamento',
      description:
        'Para criar um novo lançamento, clique aqui e siga as instruções da próxima página.',
      side: 'bottom',
      align: 'center',
    },
  },
  {
    element: '#payables-total',
    popover: {
      title: 'Lançamentos',
      description:
        'Aqui você saberá a quantidade total de lançamentos realizados até o momento.',
    },
  },
  {
    element: '#search',
    popover: {
      title: 'Pesquisa',
      description:
        'Você poderá realizar a busca para encontrar o lançamento que deseja aqui.',
      side: 'bottom',
      align: 'center',
    },
  },
  {
    element: '#filter-icon',
    popover: {
      title: 'Filtro',
      description:
        'Diversos parâmetros disponíveis para que você possa encontrar o que deseja de forma rápida e simplificada.',
      side: 'bottom',
      align: 'center',
    },
  },
  {
    element: '#fitler',
    popover: {
      title: 'Filtro',
      description:
        'O filtro poderá ser realizado por: vencimento, data de lançamento, período de vencimento, últimos lançamentos, valor, status de pagamento, fornecedor, obra, categoria e item do orçamento.',
      side: 'bottom',
      align: 'center',
    },
  },
  {
    element: '#home-view',
    popover: {
      title: 'Visão Geral da Home',
      description:
        'Aqui você verá todos os lançamentos realizados no sistema separados por colunas.',
    },
  },
  {
    element: '#due-column',
    popover: {
      title: 'Vencimento',
      description: 'Data de vencimento do lançamento.',
    },
  },
  {
    element: '#supplier-column',
    popover: {
      title: 'Fornecedor',
      description: 'Nome do fornecedor correspondente ao lançamento.',
    },
  },
  {
    element: '#description-column',
    popover: {
      title: 'Descrição',
      description:
        'Neste campo, você pode inserir um texto para auxiliar no gerenciamento dos lançamentos.',
    },
  },
  {
    element: '#construction-column',
    popover: {
      title: 'Obra',
      description: 'Nome da obra em que o lançamento foi realizado.',
    },
  },
  {
    element: '#item-column',
    popover: {
      title: 'Item',
      description: 'Quantidade de itens do orçamento vinculados ao lançamento.',
    },
  },
  {
    element: '#value-column',
    popover: {
      title: 'Valor',
      description: 'Valor total do lançamento.',
    },
  },
  {
    element: '#status-column',
    popover: {
      title: 'Status',
      description:
        'Status de pagamento do lançamento: nesta tela, você pode alterar o status do lançamento, se necessário.',
    },
  },
  {
    element: '#date-column',
    popover: {
      title: 'Lançamento',
      description: 'Data que foi realizado o lançamento.',
    },
  },
  {
    element: '#attachments-column',
    popover: {
      title: 'Anexos',
      description: 'Quantidade de anexos associados ao lançamento.',
    },
  },
  {
    element: '#duplicate-column',
    popover: {
      title: 'Duplicar',
      description: 'É possível duplicar um lançamento, se necessário.',
    },
  },
];

const clientsSteps = [
  {
    element: '#personal-info',
    popover: {
      title: 'Informações Pessoais',
      description:
        'Aqui ficam todas as informações pessoais do seu cliente, seja ele PF ou PJ.',
    },
  },
  {
    element: '#account',
    popover: {
      title: 'Conta',
      description:
        'Aqui, o administrador concede “permissão” ao usuário para visualizar, na sua área logada, abas de gestão da obra. Ele poderá acessar as telas de lançamento, orçamento, cronograma, fotos, documentos e dashboard. Para isso, é importante inserir o e-mail do usuário, que receberá um link para criar sua senha e acessar o sistema.',
    },
  },
  {
    element: '#save-client',
    popover: {
      title: 'Cadastrar Cliente',
      description: 'Salve as alterações realizadas nas informações do cliente.',
    },
  },
];

const constructionsFormSteps = [
  {
    element: '#form-button',
    popover: {
      title: 'Cadastrar Obra',
      description: 'Cadastre suas obras de forma fácil e rápida.',
    },
  },
  {
    element: '#general-info',
    popover: {
      title: 'Informações Gerais da obra',
      description: 'Todas as informações gerais da obra.',
    },
  },
  {
    element: '#construction-address',
    popover: {
      title: 'Endereço da obra',
      description: 'Endereço da obra selecionada.',
    },
  },
  {
    element: '#construction-facade',
    popover: {
      title: 'Fachada da Obra',
      description:
        'Adicione uma imagem da obra e altere o status entre ativa e encerrada.',
    },
  },
  {
    element: '#form-button',
    popover: {
      title: 'Cadastrar Obra',
      description: 'Clique aqui para salvar as alterações realizadas.',
    },
  },
];

const payablesSteps = [
  {
    element: '#payables-tab',
    popover: {
      title: 'Lançamentos',
      description:
        'Nesta tela, você visualiza todos os lançamentos realizados até o momento. Além disso, tem a opção de exportar os dados e realizar um novo lançamento.',
    },
  },
  {
    element: '#construction-name',
    popover: {
      title: 'Nome da Obra',
      description:
        'Aqui será exibido o nome da obra que você está visualizando.',
    },
  },
  {
    element: '#budget-box',
    popover: {
      title: 'Orçamento da obra',
      description:
        'Aqui você poderá acompanhar algumas das informações financeiras dessa obra.',
    },
  },
  {
    element: '#export-button',
    popover: {
      title: 'Exportar Lançamento',
      description:
        'Exporte o lançamento em um arquivo em formato .xls e salve-o no seu computador.',
    },
  },
  {
    element: '#new-payable-button',
    popover: {
      title: 'Novo Lançamento',
      description: 'Realize um novo lançamento.',
    },
  },
  {
    element: '#payables-total',
    popover: {
      title: 'Total de Lançamentos',
      description:
        'Aqui será exibida a quantidade total de lançamentos realizados no sistema até o momento.',
    },
  },
  {
    element: '#search',
    popover: {
      title: 'Campo de pesquisa',
      description:
        'Se preferir, você pode pesquisar por algum lançamento específico.',
    },
  },
  {
    element: '#home-view',
    popover: {
      title: 'Informações da obra',
      description: 'Aqui aparecerão todos os lançamentos da obra selecionada.',
    },
  },
];

const budgetsSteps = [
  {
    element: '#budgets-tab',
    popover: {
      title: 'Orçamentos',
      description:
        'Nesta tela, você visualizará o orçamento da obra selecionada. Além disso, terá a opção de exportar os dados e editar o orçamento conforme necessário.',
    },
  },
  {
    element: '#edit-budget',
    popover: {
      title: 'Editar Orçamento',
      description: 'Edite o orçamento da obra selecionada.',
    },
  },
  {
    element: '#export-budget',
    popover: {
      title: 'Exportar Orçamento',
      description:
        'Exporte o orçamento em um arquivo em formato .xls e salve-o no seu computador.',
    },
  },
  {
    element: '#budgets-table',
    popover: {
      title: 'Itens do Orçamento',
      description: 'Tabela com a listagem de itens e sub-itens do orçamento.',
    },
  },
];

const schedulesSteps = [
  {
    element: '#schedules-tab',
    popover: {
      title: 'Cronograma',
      description:
        'Nesta tela, você visualiza o cronograma da obra selecionada e pode editar as informações conforme necessário.',
    },
  },
  {
    element: '#frequency-input',
    popover: {
      title: 'Periodicidade',
      description: 'Periodicidade selecionada para a obra.',
    },
  },
  {
    element: '#periods-input',
    popover: {
      title: 'Quantidade de Períodos',
      description: 'Quantidade de períodos selecionados para a obra.',
    },
  },
  {
    element: '#initial-date-input',
    popover: {
      title: 'Data Inicial do Cronograma',
      description: 'Data inicial selecionada para a obra.',
    },
  },
  {
    element: '#edit-schedule',
    popover: {
      title: 'Editar Cronograma',
      description: 'Edite o cronograma usando um orçamento já existente.',
    },
  },
  {
    element: '#schedules-table',
    popover: {
      title: 'Tabela do Cronograma',
      description:
        'Aqui você pode registrar o andamento de cada etapa do cronograma e tem a flexibilidade de adicionar colunas conforme sua necessidade.',
    },
  },
];

const photosSteps = [
  {
    element: '#photos-tab',
    popover: {
      title: 'Fotos',
      description:
        'Nesta tela, você pode arquivar fotos e organizá-las por pastas.',
    },
  },
  {
    element: '#create-folder',
    popover: {
      title: 'Criar Pasta',
      description: 'Crie uma pasta para fazer o upload de fotos da obra.',
    },
  },
  {
    element: '#folder-table',
    popover: {
      title: 'Pastas de Fotos',
      description:
        'Aqui você encontra todas as pastas criadas e pode editar, baixar ou apagá-las. ',
    },
  },
];

const documentsSteps = [
  {
    element: '#documents-tab',
    popover: {
      title: 'Documentos',
      description:
        'Nesta tela, você pode arquivar documentos e organizá-los por pastas.',
    },
  },
  {
    element: '#create-folder',
    popover: {
      title: 'Criar Pasta',
      description: 'Crie uma pasta para fazer o upload de documentos da obra.',
    },
  },
  {
    element: '#folder-table',
    popover: {
      title: 'Pastas de Documentos',
      description:
        'Aqui você encontra todas as pastas criadas e pode editar, baixar ou apagá-las. ',
    },
  },
];

const dashboardSteps = [
  {
    element: '#dashboard-tab',
    popover: {
      title: 'Dashboard',
      description:
        'Nesta tela, você tem acesso ao dashboard da obra, com gráficos que apresentam os lançamentos de diversas maneiras.',
    },
  },
];

const suppliersSteps = [
  {
    element: '#suppliers-table',
    popover: {
      title: 'Fornecedores',
      description: 'Todos os seus fornecedores cadastrados aparecerão aqui.',
    },
  },
  {
    element: '#suppliers-search',
    popover: {
      title: 'Pesquisar Fornecedores',
      description:
        'Pesquise seus fornecedores e o resultados aparecerá abaixo.',
    },
  },
  {
    element: '#new-supplier-btn',
    popover: {
      title: 'Cadastrar Fornecedor',
      description: 'Cadastre seus fornecedores de forma fácil e rápida.',
    },
  },
  {
    element: '#company-info',
    popover: {
      title: 'Informações da Empresa',
      description:
        'É possível cadastrar um fornecedor, seja Pessoa Física (PF) ou Jurídica (PJ), preenchendo todas as informações necessárias da empresa e associando uma categoria a esse fornecedor.',
    },
  },
  {
    element: '#supplier-category',
    popover: {
      title: 'Categoria do Fornecedor',
      description:
        'Escolha e associe uma ou mais categorias que melhor se encaixam com o perfil do fornecedor.',
    },
  },
  {
    element: '#remarks',
    popover: {
      title: 'Observações',
      description:
        'Descreva detalhes do fornecedor para ajudar no gerenciamento.',
    },
  },
  {
    element: '#new-supplier-btn',
    popover: {
      title: 'Cadastrar Fornecedor',
      description:
        'Clique aqui para salvar as alterações realizadas no fornecedor.',
    },
  },
];

const categoriesSteps = [
  {
    element: '#new-category-btn',
    popover: {
      title: 'Nova Categoria',
      description: 'Cadastre uma nova categoria da sua escolha.',
    },
  },
  {
    element: '#categories-table',
    popover: {
      title: 'Categorias',
      description: 'Aqui ficam todas as categorias cadastradas na plataforma.',
    },
  },
  {
    element: '#description-column',
    popover: {
      title: 'Descrição',
      description: 'Nome da categoria cadastrada.',
    },
  },
  {
    element: '#edit-column',
    popover: {
      title: 'Editar',
      description: 'Edite a categoria a qualquer momento que precisar.',
    },
  },
  {
    element: '#delete-column',
    popover: {
      title: 'Deletar',
      description: 'Delete qualquer categoria que não quiser mais.',
    },
  },
];

const newReleaseSteps = [
  {
    element: '#payment-switch',
    popover: {
      title: 'Pagamento Efetuado',
      description:
        'Para caso o lançamento já esteja pago antes de ser lançado, basta habilitar o botão "Pagamento efetuado".',
    },
  },
  {
    element: '#payment-dropdown',
    popover: {
      title: 'Arraste o boleto',
      description:
        'Para o preenchimento automático dos campos "Obra" e "Fornecedor", o CNPJ ou CPF no boleto deve coincidir com as informações registradas. Basta arrastar o boleto para essa área pontilhada e aguardar o carregamento.',
    },
  },
  {
    element: '#payment-info',
    popover: {
      title: 'Informações Sobre o Lançamento',
      description:
        'As informações do seu lançamento serão exibidas nos campos nesta seção.',
    },
  },
  {
    element: '#budget-association',
    popover: {
      title: 'Associar a Itens do Orçamento',
      description: 'Associe itens do orçamento ao boleto.',
    },
  },
  {
    element: '#total-value',
    popover: {
      title: 'Valor Total',
      description: 'Aqui será exibido o valor total do lançamento.',
    },
  },
  {
    element: '#new-release-radio',
    popover: {
      title: 'Criar Novo Lançamento',
      description:
        'Clicando aqui no checkbox, você abrirá uma nova janela para criar um novo lançamento sem o anexo.',
    },
  },
  {
    element: '#save-btn',
    popover: {
      title: 'Salvar',
      description: 'Salve seu lançamento.',
    },
  },
  {
    element: '#save-and-attach-btn',
    popover: {
      title: 'Salvar e Anexar',
      description: 'Para anexar arquivos ao lançamento clique aqui.',
    },
  },
];

export {
  budgetsSteps,
  categoriesSteps,
  clientsSteps,
  constructionsFormSteps,
  dashboardSteps,
  documentsSteps,
  homeSteps,
  newReleaseSteps,
  onBoardingSteps,
  payablesSteps,
  photosSteps,
  schedulesSteps,
  suppliersSteps,
};
